module.exports = __webpack_public_path__ + "static/media/sc.7b4b06e6.svg";